package core.io.dto

import kotlinx.serialization.SerialName

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 10.10.22
 * Author : mariorosshirt
 */
@kotlinx.serialization.Serializable
data class MinifiedColourDTO(
    @SerialName("unique")
    val mUnique: String,

    @SerialName("name")
    val mName: String,

    @SerialName("artNr")
    val mArtNr: String,

    @SerialName("colourCode")
    val mColourCode: String,

    @SerialName("colourCollection")
    val mColourCollection: String,

    @SerialName("additionalInfo1")
    val mAdditionalInfo1: String,

    @SerialName("additionalInfo2")
    val mAdditionalInfo2: String,

    @SerialName("eanCode")
    val mEanCode: String
) {

    // ----------------------------------------------------------------------------
    // Public properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Internal properties
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Init
    // ----------------------------------------------------------------------------
    init {

    }

    // ----------------------------------------------------------------------------
    // Constructor
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // System/Overridden methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Interfaces/Listener
    // ----------------------------------------------------------------------------

}